import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
export var commonUrl = {
    filterUrl: URLConfig.config.apiBase +
        microService.masterSevice +
        "FilterMaster/FilterData",
    tierData: URLConfig.config.apiBase +
        microService.masterSevice +
        "FilterMaster/FilterData/tier",
    interactionStatus: URLConfig.config.apiBase +
        microService.leadService +
        "Master/InteractionStatus",
    interactionSubStatus: URLConfig.config.apiBase +
        microService.leadService +
        "Master/InteractionSubStatus",
    externalParticipants: URLConfig.config.apiBase +
        microService.leadService +
        "Master/ExternalParticipants",
    partners: URLConfig.config.apiBase + microService.leadService + "masters/FRMMapping",
    participants: URLConfig.config.apiBase + microService.leadService + "Master/Participants",
    product: URLConfig.config.apiBase + microService.leadService + "masters/product",
    bucket: URLConfig.config.apiBase + microService.leadService + "masters/bucket",
    category: URLConfig.config.apiBase + microService.leadService + "masters/category",
    subCategory: URLConfig.config.apiBase + microService.leadService + "masters/subcategory",
    source: URLConfig.config.apiBase + microService.leadService + "masters/Sources",
    subSources: URLConfig.config.apiBase + microService.leadService + "masters/SubSources",
    Status: URLConfig.config.apiBase +
        microService.leadService +
        "masters/BucketStatus",
    SubStatus: URLConfig.config.apiBase + microService.leadService + "masters/SubStatus",
    TypeOfContact: URLConfig.config.apiBase +
        microService.leadService +
        "Master/TypeOfContact",
    CustomerType: URLConfig.config.apiBase + microService.leadService + "Master/CustomerType",
    StandardReponse: URLConfig.config.apiBase + microService.leadService + "masters/Response",
    StandardResponseNew: URLConfig.config.apiBase + microService.leadService + "masters/ResponseMaster",
    Participants: URLConfig.config.apiBase + microService.leadService + "Master/Participants",
    ExternalParticipants: URLConfig.config.apiBase +
        microService.leadService +
        "Master/ExternalParticipants",
    LeadStatus: URLConfig.config.apiBase + microService.leadService + "Master/LeadStatus",
    DSAClientEmployee: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/DSAClientEmployee",
    SubCategoryAll: URLConfig.config.apiBase +
        microService.leadService +
        "masters/subcategoryall",
    RegistrationProduct: URLConfig.config.apiBase +
        microService.leadService +
        "masters/RegistrationProduct",
    displayName: URLConfig.config.apiBase + microService.leadService + "Master/DisplayName",
    catSubCatbyDisplay: URLConfig.config.apiBase +
        microService.leadService +
        "Master/catsubcatbydisplay",
    displayNameByCategory: URLConfig.config.apiBase +
        microService.leadService +
        "Master/DisplayNameByCategory",
    entityType: URLConfig.config.apiBase + microService.leadService + "Master/EntityType",
    Preferences: URLConfig.config.apiBase +
        microService.masterSevice +
        "filtermaster/preferences",
    potentialTier: URLConfig.config.apiBase +
        microService.leadService +
        "masters/Potentieltier",
    validateFocus: URLConfig.config.apiBase +
        microService.leadService +
        "masters/ValidateFocus",
};
